import React from 'react';
import { Routes, Route,Navigate } from 'react-router-dom';
import { Toaster } from 'react-hot-toast';
import { AuthProvider,useAuth  } from './context/AuthContext';

// Layouts
import Layout from './components/layout/Layout';


// Pages dashboard (client + smart)
import DashboardClient from './pages/DashboardClient';
import DashboardSmart from './pages/DashboardSmart';

import HomePage from './pages/HomePage';
import ServicesPage from './pages/ServicesPage';
import BookingPage from './pages/BookingPage';
import BecomeSmartPage from './pages/BecomeSmartPage';
import LoginPage from './pages/LoginPage';
import RegisterPage from './pages/RegisterPage';
import AboutPage from './pages/AboutPage';
import ContactPage from './pages/ContactPage';
import FaqPage from './pages/FaqPage';
import PricingPage from './pages/PricingPage';
import NotFoundPage from './pages/NotFoundPage';
import PrivacyPage from './pages/legal/PrivacyPage';
import TermsPage from './pages/legal/TermsPage';
import LegalNoticePage from './pages/legal/LegalNoticePage';
import CookiesPage from './pages/legal/CookiesPage';
import GdprPage from './pages/legal/GdprPage';
import ScrollToTop from './components/ScrollToTop';

const LoadingScreen = () => (
  <div className="min-h-screen bg-[#0a0a0a] flex items-center justify-center text-white">Chargement...</div>
);

// Rôles de l'application mobile : `smart` et `livreur` partagent le même espace
const SMART_ROLES = ['smart', 'livreur'];

/**
 * Route protégée.
 * Trois cas distincts : pas de session, session sans profil métier
 * (inscription interrompue), et rôle inadapté.
 *
 * L'administration n'a pas sa place ici : elle a ses propres applications
 * (BackOffice Vadom), qui attaquent Firestore directement.
 */
const ProtectedRoute = ({ children, allowedRoles }) => {
  const { user, loading, needsProfile } = useAuth();

  if (loading) return <LoadingScreen />;

  // Compte Firebase valide mais document `Utilisateur` absent : il reste
  // la dernière étape de l'inscription à terminer
  if (needsProfile) return <Navigate to="/register" replace />;

  if (!user) return <Navigate to="/login" replace />;

  if (allowedRoles && !allowedRoles.includes(user.role)) {
    if (SMART_ROLES.includes(user.role)) return <Navigate to="/smart/dashboard" replace />;
    return <Navigate to="/dashboard" replace />;
  }

  return children;
};

function App() {
  return (
    <AuthProvider>
      <ScrollToTop />
      <Toaster 
        position="top-right"
        toastOptions={{
          duration: 4000,
          style: { 
            borderRadius: '12px', 
            padding: '16px',
            background: '#252525',
            color: '#FFFFFF',
            border: '1px solid #333333'
          },
        }}
      />
      <Routes>
        <Route path="/" element={<Layout />}>
          {/* Pages principales */}
          <Route index element={<HomePage />} />
          <Route path="services" element={<ServicesPage />} />
          <Route path="services/:category" element={<ServicesPage />} />
          
          {/* Réservation - les deux formats */}
          <Route path="book" element={<BookingPage />} />
          <Route path="book/:serviceId" element={<BookingPage />} />
          
          {/* Autres pages */}
          <Route path="smarts/:id" element={<BecomeSmartPage />} />
          <Route path="become-smart" element={<BecomeSmartPage />} />
          <Route path="login" element={<LoginPage />} />
          <Route path="register" element={<RegisterPage />} />
          <Route path="about" element={<AboutPage />} />
          <Route path="contact" element={<ContactPage />} />
          <Route path="faq" element={<FaqPage />} />
          <Route path="pricing" element={<PricingPage />} />
          <Route path="legal/privacy" element={<PrivacyPage />} />
          <Route path="legal/terms" element={<TermsPage />} />
          <Route path="legal/legal-notice" element={<LegalNoticePage />} />
          <Route path="legal/cookies" element={<CookiesPage />} />
          <Route path="legal/gdpr" element={<GdprPage />} />

          {/* Routes dashboard protégées */}
          <Route path="dashboard" element={
            <ProtectedRoute allowedRoles={['visiteur', 'en_attente', 'recruteur']}>
              <DashboardClient />
            </ProtectedRoute>
          } />
          <Route path="smart/dashboard" element={
            <ProtectedRoute allowedRoles={SMART_ROLES}>
              <DashboardSmart />
            </ProtectedRoute>
          } />

          {/* Page 404 */}
          <Route path="*" element={<NotFoundPage />} />


        </Route>
      </Routes>
    </AuthProvider>
  );
}

export default App;